import React, { useEffect, useRef, useState } from 'react';
import { number, string, node, oneOf } from 'prop-types';

import * as S from './styles';

const Tooltip = props => {
  const { children, className, title, placement, width, align } = props;

  const [parentWidth, setParentWidth] = useState(null);

  const containerRef = useRef(null);

  useEffect(() => {
    if (!window || !containerRef.current) {
      return;
    }

    setParentWidth(containerRef.current.getBoundingClientRect().width);
  }, []);

  return (
    <S.TooltipWrapper ref={containerRef} className={className}>
      {title && (
        <S.Tooltip
          placement={placement}
          width={width}
          align={align}
          parentWidth={parentWidth}
          data-test="Tooltip"
        >
          {title}
        </S.Tooltip>
      )}
      {children}
    </S.TooltipWrapper>
  );
};

Tooltip.propTypes = {
  children: node.isRequired,
  className: string,
  title: string,
  placement: oneOf(['top', 'bottom', 'left', 'right']),
  align: oneOf(['left', 'right', 'center']),
  width: number,
};

Tooltip.defaultProps = {
  className: undefined,
  title: undefined,
  placement: 'bottom',
  align: 'center',
  width: undefined,
};

export default Tooltip;
